import React, { useState } from "react";
import { Input, Col, Row, Form, notification, Button, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Screen from "../../util/Extensions/Screens";
import RequestHandler from "../../util/RequestHandler";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const openNotificationWithIcon = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Ekleme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};

const UserAddForm = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    RequestHandler.post(
      `/Auth/RegisterWithTenant`,
      {
        email: values.Email,
        salesCode: values.ErpSalesCode,
        firstName: values.FirstName,
        lastName: values.LastName,
        phoneNumber: values.PhoneNumber,
        screenOption: Screen.screen,
        isB2bAdmin: values.isB2bAdmin,
        isB2bCancel: values.isB2bCancel,
        isB2bFirmAdmin: values.isB2bFirmAdmin,
        posSalesCode: values.ErpSalesCodeForPosReport,
        salesCodeGroup: values.SalesCodeGroup,
        isSalesCodeGroupAdmin: values.isSalesCodeGroupAdmin,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status === 200) {
        openNotificationWithIcon("success");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        setLoading(false);
      }
    })
    .catch(() => setLoading(false));
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <div>
      {isDesktopOrLaptop && (
        <>
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={2}></Col>
              <Col span={17}>
                <Form.Item
                  label="Ad"
                  name="FirstName"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Ad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Soyad"
                  name="LastName"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Soyad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="E-Posta Adresi"
                  name="Email"
                  validateTrigger="onSubmit"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen E-Posta Adresi alanını boş bırakmayın.",
                    },
                    { 
                      type: "email", 
                      message: "Lütfen geçerli bir e-posta adresi giriniz." 
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input />
                </Form.Item>

                <Form.Item label="Satıcı Kodu (Pos)" name="ErpSalesCodeForPosReport">
                  <Input />
                </Form.Item>

                <Form.Item label="Satıcı Grubu" name="SalesCodeGroup">
                  <Input  />
                </Form.Item>


                <Form.Item
                  label="Telefon Numarası"
                  name="PhoneNumber"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                    {
                      required: true,
                      message:
                        "Lütfen Telefon Numarası alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <PhoneInput
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>

                <Form.Item
                  label="B2B Yöneticisi"
                  name="isB2bAdmin"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch />
                </Form.Item>
                <Form.Item
                  label="B2B Bayi Yöneticisi"
                  name="isB2bFirmAdmin"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch />
                </Form.Item>
                <Form.Item
                  label="B2B İşlem İptali"
                  name="isB2bCancel"
                  valuePropName="checked"
                  style={{
                    visibility: props.modules.includes(8)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  label="Satıcı Grup Yöneticisi"
                  name="isSalesCodeGroupAdmin"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={5}></Col>
              <Col span={6}></Col>
              <Col span={9}></Col>
              <Col span={7}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={2}></Col>
            </Row>
          </Form>
        </>
      )}
      {isTabletOrMobileDevice && (
        <>
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Ad"
                  name="FirstName"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Ad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Soyad"
                  name="LastName"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Soyad alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="E-Posta Adresi"
                  name="Email"
                  validateTrigger="onSubmit"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen E-Posta Adresi alanını boş bırakmayın.",
                    },
                    { 
                      type: "email", 
                      message: "Lütfen geçerli bir e-posta adresi giriniz." 
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input />
                </Form.Item>

                <Form.Item label="Satıcı Kodu (Pos)" name="ErpSalesCodeForPosReport">
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Telefon Numarası"
                  name="PhoneNumber"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                    {
                      required: true,
                      message:
                        "Lütfen Telefon Numarası alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <PhoneInput
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </>
      )}
    </div>
  );
};
export default UserAddForm;
